import React, { Component } from 'react';
import { Link, Route, Switch } from "react-router-dom";
import { connect } from "react-redux"

import Modal from 'react-responsive-modal';
import agent from '../agent'

import AMLogo from '../assets/images/audition-magic-favicon.png';
import Aux from './AuxContainer'
import ClientProjectSettingsContainer from './ClientProjectSettingsContainer'
import Back from "../components/Back";

import ProjectLinkUrlModal from '../components/modals/ProjectLinkUrlModal'
import ProjectConfirmationModal from '../components/modals/ProjectConfirmationModal'

const ProjectList = ({isAdminMode, user, project, onOpenModal}) => (
	isAdminMode
	?	<Aux>
			<div className={`column column-block`} key={project.id}>
				<div className="project-item-container">

			    <div className="image-container">
			    	<img className="project-image" src={project.cover_url || AMLogo } alt="" />
			    </div>
			    <div className="card-divider align-justify">
			      	{
			      	// <div className="status">
			      	// 	<input type="radio" name="project" value="airbnb" id="airbnb-1" readOnly />
			      	// 	<label htmlFor="airbnb-1">Active</label>
			      	// </div>
			      	<div className="status">
				      	<label className="project-name">{project.name}</label>
			      	</div>
			      	}
			      	<div className="project-actions card-actions active ">
			      		<Link to={`/projects/settings/${project.id}`}>
			      		<i className="fa fa-cog" aria-hidden="true"></i></Link>
				      	<i className="fa fa-link" aria-hidden="true" onClick={onOpenModal} ></i>
			      	</div>
			    </div>

			   </div>
			</div>
		</Aux>
	: <Aux>
			<div className={`column column-block`} key={project.id}>
				<div className="project-item-container">

				<Link 
				to={{
					pathname:`/artist/login`, 
					search: `?project=${project.id}`,
					state: { projectId: project, client: user } }}>
			    <div className="image-container">
			    	<img src={project.cover_url || AMLogo} alt=""/>
			    </div>
			    <div className="card-divider">
				    <div className="status">
		      	<label className="project-name">{project.name}</label>
		      	</div>
	      	</div>
			  </Link>

			  </div>
			</div>
		</Aux>
)


const Header = ({user, adminMode}) => (
<section id="brand-logo" className="section-brand-logo project-list section">
  <div className="row">
  <div className="small-12 small-centered column text-center">
  	<div className="header-image-container">
  	{
  		user && user.default_company_details
  		? <img className="company-logo" src={ user.default_company_details.logo_url } alt="" />
  		: <img className="am-logo" src={ AMLogo } alt="" />
  	}
  	</div>
  	<div className="post-relative">
  	<Back />
    { adminMode
    		? <p className="top-title">Hey {user && user.default_company_details ? user.default_company_details.canonical_name : 'There'}! please activate projects for Artist Checkin</p>
    		: <p className="top-title">Please select the project you are auditioning below</p>
    }
    </div>
  </div>
  </div>
</section>
)

const Logout = (props) => (	
	props.appLoaded && props.clientToken
	?	<span className="logout-btn fa-stack fa-1x" onClick={props.onClickLogout} >
		  <i className="fa fa-circle fa-stack-2x icon-background"></i>
		  <i className="fa fa-sign-out fa-stack-1x"></i>
		</span>
  : ''
)

class ClientProjectsListContainer extends Component {
	state = { 
		adminMode: true ,
		currentProject: null,
		showProjectLinkModal: false,
		showConfirmationModal: false,
	}
	componentWillMount() {
		console.log('>>clientProjectList', this.props);
		const { clientToken } = this.props
	
	  const user = agent.Client.getUser(clientToken.id)
	  const projects = user.then(({user}) => agent.Client.getProjects(user.default_company_id))

		this.props.onLoad(
		  Promise.all([
			  user,
			  projects
			])
		)
  }

  updateAdminMode = () => {
  	this.setState({
  		adminMode: false
  	})
  	this.onCloseModal('showConfirmationModal');
  }

  componentWillUnmount() {
	  this.props.onUnload()	
  }

  onOpenModal = (modal, project) => {
    this.setState({ 
    	[modal]: true,
			currentProject: modal === 'showProjectLinkModal' && project
    });
  }
  
  onCloseModal = (modal) => {
    this.setState({ [modal]: false });
  }

	render() {
		const { projects, user } = this.props;
		console.log('ito na', projects)
		if (this.props.projects) {

			if (!this.props.projects.length) {
				return (
					<div>
						<Header {...this.props} adminMode={this.state.adminMode}/>
						<Logout {...this.props }/>
						<section id="project-selection" className="section-getting-started gray-bg section">
							<p className="text-center loading-text">Sorry you currently you don't have any projects to manage at this time</p>
						</section>
					</div>
				)
			}

			return (
				<div>

				<Header {...this.props} adminMode={this.state.adminMode}/>
				<Logout {...this.props }/>
			
				<section id="project-selection" className="section-getting-started gray-bg section">
					<div className="row">
					<div className="small-12 small-centered columns text-center">
					<div className="row small-up-1 medium-up-2 large-up-3">
						{ projects.map(project => 
								<ProjectList 
									key={project.id}
									project={project} 
									user={user}
									isAdminMode={this.state.adminMode}
									onOpenModal={() => this.onOpenModal('showProjectLinkModal', project)} />
						)}
					</div>
					
					{ this.state.adminMode && 
						<button 
							className="button primary" 
							onClick={() => this.onOpenModal('showConfirmationModal')}>
							Save & Enter Checkin Mode</button> 
					}

					</div>
					</div>

					<ProjectConfirmationModal 
        	open={this.state.showConfirmationModal}
        	onClose={() => this.onCloseModal('showConfirmationModal')}
        	updateAdminMode={this.updateAdminMode} />
					
					<ProjectLinkUrlModal 
						currentProject={this.state.currentProject}
						showProjectLinkModal={this.state.showProjectLinkModal}
						onCloseModal={() => this.onCloseModal('showProjectLinkModal')}
					/>

				</section>	
				</div>
			)
		}

		return (
			<div>
				<Header {...this.props}/>
				<Logout {...this.props }/>
				<section className="gray-bg section">
					<p className="text-center loading-text">Loading Projects...</p>
				</section>
			</div>
			
		)

	}
}

const mapStateToProps = state => ({
  ...state.auth,
  ...state.common,
  ...state.client,
})
const mapDispatchToProps = (dispatch) => ({
	onLoad: payload =>
		dispatch({ type: 'PROJECT_PAGE', payload: payload}),
	onUnload: () => 
		dispatch({ type: 'PROJECT_PAGE_UNLOADED' }),
  tickIncrement: () => dispatch({ type: 'TICK' }),
  onClickLogout: () =>
		dispatch({ type: 'LOGOUT' })
})
export default connect(mapStateToProps, mapDispatchToProps)(ClientProjectsListContainer)


// WEBPACK FOOTER //
// ./src/containers/ClientProjectsListContainer.js